import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { format } from 'date-fns';
import { useUtils, useExpander, useConfig } from 'app/hooks';
import { List, ListItem, ListItemLink, NoDays, Panel } from './styles';

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired
    })
  ).isRequired,

  movieId: PropTypes.string.isRequired,
  movieTitle: PropTypes.string.isRequired,
  cinemaId: PropTypes.string.isRequired,

  shownCount: PropTypes.number
};

const defaultProps = {
  shownCount: 6
};

const Accordion = ({ children }) => {
  const [t] = useTranslation();
  const { Trigger, Expander, isExpanded } = useExpander();

  return (
    <Fragment>
      <Expander>{children}</Expander>

      <Panel>
        {isExpanded ? t('common.show_less') : t('common.show_more')}
        <Trigger />
      </Panel>
    </Fragment>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired
};


const getTranslatedDayName = (date, t) => {
  const dayOfWeek = date.getDay() + 1;
  const adjustedDayIndex = (dayOfWeek === 0) ? 7 : dayOfWeek;

  const translationKey = `common.day_of_week_${adjustedDayIndex}`;
  return t(translationKey);
}

function getTranslatedMonthName(date, t) {
  const monthIndex = date.getMonth() + 1;
  return t(monthIndex > 9 ? `common.short_month_${monthIndex}` : `common.short_month_0${monthIndex}`);
}

const printDay = (t, getDateWithOffset) => d => {
  const date = getDateWithOffset(d);

  const translatedDayName = getTranslatedDayName(date, t);
  const translatedMonthName = getTranslatedMonthName(date, t);
  return `${t(translatedDayName)}, ${format(
    date,
    'd'
  )} ${t(translatedMonthName)}, ${format(date, 'yyyy')}`;
};


// const printDay = (t, getDateWithOffset) => d => {
//   const date = getDateWithOffset(d);
//   return `${t('show_long_day', { date })}, ${format(
//     date,
//     'd'
//   )} ${t('show_short_month', { date })}, ${format(date, 'yyyy')}`;
// };

const SessionsDays = ({ items, shownCount, movieId, movieTitle, cinemaId }) => {
  const [t] = useTranslation();
  const { getDateWithOffset } = useUtils();
  const { routes } = useConfig();
  const showDay = printDay(t, getDateWithOffset);
  const ref = useRef(null);

  const ids = sessions => {
    const sessionIds = sessions.map(sessionId => sessionId.id);

    return sessionIds;
  };

  const handleClick = (sessionId) => {
    const selectedSessionInfo = {
      sessionId,
      scrollPosition: window.pageYOffset
    };
    // localStorage.setItem('selectedSessionData', JSON.stringify(selectedSessionInfo));
  };

  useEffect(() => {
    const isMobile = window.innerWidth < 992;
    if (isMobile) {
      const data = JSON.parse(localStorage.getItem('selectedSessionData'));
      // if (data) {
      //   setTimeout(() => {
      //     const element = document.querySelector(`#data-${data.sessionId}`);
      //     if (element) {
      //       const yOffsetMobile = -300;
      //       const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffsetMobile;
      //       window.scrollTo({ top: yPosition, behavior: 'smooth' });
      //     }
      //   }, 100);
      //   localStorage.removeItem('selectedSessionData');
      // }
      window.scrollTo(0, 0);
    }
    else {
      const data = JSON.parse(localStorage.getItem('selectedSessionData'));
      // if (data) {
      //   setTimeout(() => {
      //     const element = document.querySelector(`#data-${data.sessionId}`);
      //     if (element) {
      //       const yOffsetMobile = -100;
      //       const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffsetMobile;
      //       window.scrollTo({ top: yPosition, behavior: 'smooth' });
      //     }
      //   }, 100);
      //   localStorage.removeItem('selectedSessionData');
      // }
      window.scrollTo(0, 0);
    }
  }, []);


  return (
    <Fragment>
      {items.length ? (
        <List>
          {items.slice(0, shownCount).map(({ date, sessions }) => (
            <ListItem key={date}>
              <ListItemLink
                id={`data-${format(
                  getDateWithOffset(date),
                  'yyyy-MM-dd'
                )}-${cinemaId}`}
                ref={ref}
                to={{
                  pathname: generatePath(routes.movieDetails.pattern, {
                    id: movieTitle.replaceAll(' ', '-')
                  }),
                  search: `?date=${format(
                    getDateWithOffset(date),
                    'yyyy-MM-dd'
                  )}&location=all&cinemaId=${cinemaId}&sessionId=${ids(sessions)}`,
                  state: { movieId, scrollTo: true }
                }}
                onClick={() => handleClick(`${format(
                  getDateWithOffset(date),
                  'yyyy-MM-dd'
                )}-${cinemaId}`)}
              >
                {showDay(date)}
              </ListItemLink>
            </ListItem>
          ))}
        </List>
      ) : (
        <NoDays>{t('common.preselling')}</NoDays>
      )}

      {items.slice(shownCount, items.length - 1).length ? (
        <Accordion>
          <List>
            {items.slice(shownCount, items.length).map(({ date, sessions }) => (
              <ListItem key={date}>
                <ListItemLink
                  id={`data-${format(
                    getDateWithOffset(date),
                    'yyyy-MM-dd'
                  )}-${cinemaId}`}
                  ref={ref}
                  to={{
                    pathname: generatePath(routes.movieDetails.pattern, {
                      id: movieTitle.replaceAll(' ', '-')
                    }),
                    search: `?date=${format(
                      getDateWithOffset(date),
                      'yyyy-MM-dd'
                    )}&location=all&cinemaId=${cinemaId}&sessionId=${ids(sessions)}`,
                    state: { movieId, scrollTo: true }
                  }}
                  onClick={() => handleClick(`${format(
                    getDateWithOffset(date),
                    'yyyy-MM-dd'
                  )}-${cinemaId}`)}
                >
                  {showDay(date)}
                </ListItemLink>
              </ListItem>
            ))}
          </List>
        </Accordion>
      ) : null}
    </Fragment>
  );
};

SessionsDays.defaultProps = defaultProps;
SessionsDays.propTypes = propTypes;
export default SessionsDays;
